<script>
export default {
    props: {
        message: {
            type: String,
            default: 'No Data Found'
        },
    }
}
</script>

<template>
    <div class="flex h-full items-center justify-center">
        <div class="flex flex-col items-center justify-center space-y-0.5">
            <span class="lnr icon-inbox !text-4xl !text-gray-500 mb-2 inline-block w-8 text-center"></span>
            <span class="text-base font-medium">{{ message }}</span>
        </div>
    </div>
</template>